import { createSelector } from 'reselect'

const selectTalentPoolDomain = () => state => state.get('talentPool')

export const selectTalentPool = () => createSelector(
  selectTalentPoolDomain(),
  state => state.get('list')
)
